import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { isEmpty } from 'ramda'
import { DateUtils, StateLabel, TextInteractive } from '@pbt/pbt-ui-components'

import { MembershipPaymentStatus } from '~/constants/paymentTypes'
import type { MembershipPayment } from '~/types'

const useStyles = makeStyles(
  (theme) => ({
    stateLabel: {
      marginLeft: theme.spacing(0.75),
    },
  }),
  { name: 'MembershipPaymentDateCell' },
)

const MembershipPaymentDateCell = (item: MembershipPayment) => {
  const classes = useStyles()
  const { t } = useTranslation('Common')

  const isLoading = isEmpty(item)
  const isNext = item.status === MembershipPaymentStatus.NEXT
  const date = DateUtils.formatDate(item.transactionDate)

  return (
    <Grid container item alignItems="center">
      <TextInteractive isLoading={isLoading}>
        {isNext ? `${t('Common:DUE_DATE')}: ` : ''}
        {date}
      </TextInteractive>
      {isNext && (
        <StateLabel warning className={classes.stateLabel} variant="small">
          {t('Common:PAYMENTS.NEXT_PAYMENT')}
        </StateLabel>
      )}
    </Grid>
  )
}

export default MembershipPaymentDateCell
